import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "../../../../Utilities/DraggableModal";
import { AgGridReact } from "ag-grid-react";
import useFetch from "../../../../Utilities/useFetch";

const StatusHistoryModal = ({ show, onHide, debtorID }) => {
  const { data: statusHistory, loading, error } = useFetch(
    show && debtorID,
    `${process.env.REACT_APP_API_URL}/Claims/GetDebtorStatusHistory`,
    "GET",
    null,
    { debtorID }
  );

  const columnDefs = [
    { headerName: "Collector", field: "collector", sortable: true, filter: true },
    { headerName: "Old Status", field: "oldStatus", sortable: true, filter: true },
    { headerName: "New Status", field: "newStatus", sortable: true, filter: true },
    { 
      headerName: "Date Changed", 
      field: "dateChanged", 
      sortable: true, 
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString();
      }
    }
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>Status Change History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading status history...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger">Failed to load status history</div>
        ) : !statusHistory || statusHistory.length === 0 ? (
          <p>No status change history available</p>
        ) : (
          <div className="ag-theme-quartz" style={{ height: '50vh', width: '100%' }}>
            <AgGridReact
              rowData={statusHistory}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
              domLayout="normal"
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default StatusHistoryModal;